var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSetValue = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M10.547 12q0 .495-.157.909a2.1 2.1 0 0 1-.44.712q-.284.3-.683.464t-.885.165H6.75v-4.5h1.632q.485 0 .885.168.399.165.683.464.284.295.44.71.157.413.157.908m-.813 0a2.2 2.2 0 0 0-.095-.663 1.4 1.4 0 0 0-.269-.498 1.15 1.15 0 0 0-.426-.314 1.4 1.4 0 0 0-.562-.109h-.83v3.168h.83q.315 0 .562-.109.252-.108.426-.311a1.5 1.5 0 0 0 .27-.498A2.2 2.2 0 0 0 9.733 12Zm4.131-2.25v.666H11.97v1.248h1.493v.644H11.97v1.273h1.895v.669h-2.697v-4.5zm3.385 0v.666h-1.896v1.332h1.6v.669h-1.6v1.833h-.801v-4.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSetValue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/set-value.13d51fba.svg";